export const SDK_LOADER_CONFIG_SCRIPT_SELECTOR = "script[data-sdk-config]";
